export const DEFAULT_MAX_RECOMMENDATIONS = 6;
export const LUMAPPS_RECO_ORIGIN = 'lumapps-recommendation';
